module.exports = __webpack_public_path__ + "images/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./~/vue-blu/dist/fonts/fontawesome-webfont.eot
// module id = 376
// module chunks = 2